function initCountrySelector() {

 //Get the modal
 const buttonLoaderCs = document.getElementById("button-country-selector-loader");
 const modal = document.getElementById("modal_geolocation");
 var closeBtn = document.getElementsByClassName("close")[0] ;
 const form = modal?.querySelector("#country-selector-form");
 const countryCode = form?.querySelector('input[name="country_code"]')
 const continentSelect = form?.querySelector('#data-continent');
 const countrySelect = form?.querySelector('#data-county');
 const countrySelectorSwitcher = modal?.querySelector(".country-selector-switch");
 const countrySelector = modal?.querySelector(".country-selector");
 const recommendationSelector = modal?.querySelector(".recommendation-selector");
 let isFirstLoad = true;
 let isoCode = Shopify.country;
 
 // When the user clicks on the button, open the modal
 async function openModalGeolocation(e) {
  e.preventDefault();
  recommendationSelector.style.display = "none";
  countrySelector.style.display = "block"
  modal.style.display = "block";
 }
  // When the user clicks on the close Button, close the modal
  if (closeBtn) {
    closeBtn.onclick = function() {
      saveLastShownDate();
      location.reload()
    }  
  }

 buttonLoaderCs.addEventListener('click', openModalGeolocation)

 // When the user clicks anywhere outside of the modal, close it
 window.onclick = function (event) {
   if (event.target == modal) {
     saveLastShownDate();
     location.reload()
   }
 }

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

function shouldShowPopup() {
  const lastShownDate = getCookie('welcome_modal_closed');
  if (!lastShownDate) {
    return true;
  }
  const currentDate = new Date();
  const lastShown = new Date(lastShownDate);
  // Calculate the time difference in milliseconds
  const timeDifference = currentDate - lastShown;

  // Convert the time difference to hours
  const hoursDifference = timeDifference / (1000 * 60 * 60);

  return hoursDifference > 24 ;
}

function saveLastShownDate() {
  const currentDate = new Date();
  // Calculate expiration date as 24 hours after the current date
  const expirationDate = new Date(currentDate.getTime() + (24 * 60 * 60 * 1000));
  document.cookie = `welcome_modal_closed=${currentDate.toISOString()}; expires=${expirationDate.toUTCString()}; path=/`;
}

 // add event function to close select on click
    const listCountrySelector = document.querySelectorAll('ul[data-ul-click]');
    if (listCountrySelector){
        listCountrySelector.forEach( ul => {
            //add event listener for each ul to close onClick
            ul.addEventListener('click', () => {
                document.querySelector('#details-cs-form').removeAttribute('open');
                document.querySelector('#details-cs-form2').removeAttribute('open');
            })
    });
    }


  countrySelectorSwitcher.addEventListener( 'click', function(e) {
    e.preventDefault();
    this.parentNode.style.display="none"
    countrySelector.style.display="block"
  })

  function updateCountryOptions() {
    const selectedContinent = continentSelect.value;
    const countryOptions = countrySelect.querySelectorAll('option');
    const selectedContinentOptions = countrySelect.querySelectorAll(`[data-input-country-market="${selectedContinent}"]`);

    countryOptions.forEach(option => {
      option.style.display = 'none';
    });

    selectedContinentOptions.forEach(option => {
      option.style.display = 'block';
    });

    if (!isFirstLoad) {
      const firstVisibleCountry = countrySelect.querySelector(`[data-input-country-market="${selectedContinent}"]:not([style*="display: none"])`);
      if (firstVisibleCountry) {
        firstVisibleCountry.selected = true;
        isoCode = firstVisibleCountry.getAttribute('iso-code');
        countryCode.value = isoCode
        shop = firstVisibleCountry.getAttribute('data-country-shop');
      }
    }
    isFirstLoad = false;
  }
  updateCountryOptions();
  continentSelect.addEventListener('change', updateCountryOptions);

  //country selector from
  var shop = countrySelect?.options[countrySelect.selectedIndex]?.getAttribute('data-country-shop');
  
  countrySelect.addEventListener('change', event => {
      event.preventDefault();
      const selectedOption = event.target.options[event.target.selectedIndex];
      isoCode = selectedOption.getAttribute('iso-code');
      countryCode.value = isoCode
      shop = selectedOption.getAttribute('data-country-shop');
  }); 


  form.addEventListener("submit", event => {
    event.preventDefault();
    saveLastShownDate();
  
    if (shop.includes(Shopify.shop)){
      form.submit();
    }else{
      let paramsAppend = themeVariables.routes.requestPath;
      if ( themeVariables.routes.rootUrl != '/' ){
        paramsAppend = paramsAppend.replace(themeVariables.routes.rootUrl, "");
      }

      if(location.search){
        paramsAppend += location.search;
      }

      const shopWithParams = shop+''+paramsAppend

      location.href = shopWithParams;
      
    }

  });

  (async () => {
    if (!window.location.pathname.includes('/cart')) return;
      try {
        let response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) throw new Error('Failed to fetch cart data');

        let cartContents = await response.json();
        let totalCart = cartContents.total_price / 100;

        ['localized-country-shipping-cart', 'localized-country-express-shipping-cart'].forEach(selector => {
          let element = document.querySelector(`#${selector}`);
          if (!element) return;
        
          let priceAttr = element.getAttribute("data-price");
          if (!priceAttr) return;
          let format;
          if (priceAttr.includes(",")) {
            format = "en-US";
          } else if (priceAttr.includes(".")){
            format = "de-DE";
          }
          let priceValue = priceAttr.toString().replace(/[a-zA-Z$€¥.,?]/g, '');

          priceValue = parseFloat(priceValue); 
          let currencySymbol = priceAttr.replace(/[0-9.,]/g, "").trim();
          let parentParagraph = element.closest("p");
          let adjustedPrice;
        
          if (priceAttr.startsWith(currencySymbol)) {
            adjustedPrice = currencySymbol + (priceValue - totalCart).toLocaleString(format);
          } else {
            adjustedPrice = (priceValue - totalCart).toLocaleString(format) + currencySymbol;
          }
        
          if (priceValue <= totalCart) {
            parentParagraph?.classList.remove("visually-hidden");
            parentParagraph.innerHTML = themeVariables.strings.freeDelivery;
          } else {
            element.innerHTML = adjustedPrice;
            parentParagraph?.classList.remove("visually-hidden");
          }
        });

      } catch (error) {
         console.error('Error updating shipping prices:', error);
      }
  })();


  function updatePopUpContent(geolocatedCountry) {
    let spanCountry1 = form?.querySelector('#localized-country-1');
    let spanCountry2 = form?.querySelector('#localized-country-2');
    let taxMsgHTML = form?.querySelector('#notice-tax-msg');
    let shippingMsgHTML = form?.querySelector('#notice-shipping-msg');
    let returnMsgHTML = form?.querySelector('#notice-retrun-msg');
    let paymentsHTML = form?.querySelector('.payment_method_flex');
    let shippingExpressMsgHTML = form?.querySelector('#notice-shipping-express-msg');

    // change the welcome message 
    if(spanCountry1 && spanCountry2) {
      if ( geolocatedCountry.handle === 'GB' || geolocatedCountry.handle === 'US' || geolocatedCountry.handle === 'AE' ){
        const isoCode =  geolocatedCountry.handle === 'GB' ? 'UK' : geolocatedCountry.handle;
        spanCountry1.innerHTML = Shopify.locale === 'en' ? `the ${isoCode}` : isoCode;
        spanCountry2.innerHTML = isoCode;
      }else if( geolocatedCountry.handle === 'CI' || geolocatedCountry.handle === 'NL' || geolocatedCountry.handle === 'PH' ){
        spanCountry1.innerHTML = Shopify.locale === 'en' ? `the ${geolocatedCountry.name }` : geolocatedCountry.name;
        spanCountry2.innerHTML = geolocatedCountry.name;
      }else{
        spanCountry1.innerHTML = geolocatedCountry.name;
        spanCountry2.innerHTML = geolocatedCountry.name;
      }
    }

    // get information of geolocated country
    const customerCountry = Object.values(themeVariables.settings.countryMatrixMetaobject).flat().find(c => c.ISOCode === geolocatedCountry.handle);
    const defaultCountry = Object.values(themeVariables.settings.countryMatrixMetaobject).flat().find(c => c.ISOCode === Shopify.country);

    //Change the selected country on the country selector to the geolocated country
    if(continentSelect && countrySelect && customerCountry) {
      continentSelect.value = customerCountry.Continent;
      continentSelect.dispatchEvent(new Event('change'));

      countrySelect.value = customerCountry.ISOCode;
      countrySelect.dispatchEvent(new Event('change'));
    }

    const taxConfig = {
      'zone_eu': themeVariables.strings.noticeTaxMsgZoneEu,
      'hidden_forced_ddp': themeVariables.strings.noticeTaxMsgHiddenForcedDdp,
      'partial_forced_ddp': themeVariables.strings.noticeTaxMsgPartialForcedDdp,
      'forced_ddp': themeVariables.strings.noticeTaxMsgForcedDdp,
      'ddu': themeVariables.strings.noticeTaxMsgDdu
    }

    //Change tax message
    if(defaultCountry?.Tax && taxConfig[defaultCountry?.Tax?.toLowerCase()]){
      if(taxMsgHTML) {
        taxMsgHTML.innerHTML = taxConfig[defaultCountry?.Tax?.toLowerCase()]?.replace(/<span id="localized-country-tax">.*?<\/span>/, `<span id="localized-country-tax">${defaultCountry?.Currency}</span>`);
      }
    }else{
      if(taxMsgHTML) {
        taxMsgHTML.classList.add("visually-hidden");
      }
    }

    //Change shipping standard message 
    if(defaultCountry?.Free_shipping_standard_threshold){
      if(shippingMsgHTML) {
        shippingMsgHTML.innerHTML = themeVariables.strings.noticeShippingMsg.replace(/<span id="localized-country-shipping">.*?<\/span>/, `<span id="localized-country-shipping">${defaultCountry?.Free_shipping_standard_threshold}</span>`)
      }
    }else{
      if(shippingMsgHTML) {
        shippingMsgHTML.classList.add("visually-hidden");
      }
    }

    //Change shipping express message 
    if(defaultCountry?.Free_shipping_express_threshold){
      if(shippingExpressMsgHTML) {
        shippingExpressMsgHTML.innerHTML = themeVariables.strings.noticeShippingExpressMsg.replace(/<span id="localized-country-express-shipping">.*?<\/span>/, `<span id="localized-country-express-shipping">${defaultCountry?.Free_shipping_express_threshold}</span>`)
      }
    }else{
      if(shippingExpressMsgHTML) {
        shippingExpressMsgHTML.classList.add("visually-hidden");
      }
    }

    //change return message
    if(defaultCountry?.Return){
      if(returnMsgHTML) {
        returnMsgHTML.innerHTML = themeVariables.strings.noticeReturnMsg.replace(/<span id="localized-country-return">.*?<\/span>/, `<span id="localized-country-return">${defaultCountry?.Return}</span>`)
      }
    }else{
      if(returnMsgHTML) {
        returnMsgHTML.classList.add("visually-hidden");
      }
    }

    //change payments icons
    if(!defaultCountry?.Payment && paymentsHTML){
      paymentsHTML.classList.add("visually-hidden");
    }
  }
  
  const countryMatrix = Object.values(themeVariables.settings.countryMatrixMetaobject).flat().map(c => c.ISOCode);

  //Show recommendation popup only for customer that is not on the right site
 fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`).then(res => res.json()).then(location => {
  if (shouldShowPopup() && location.detected_values.country.handle != Shopify.country && countryMatrix.some((item) => item == location.detected_values.country.handle) && !Shopify.designMode) {
    updatePopUpContent(location.detected_values.country)
    modal.style.display = "block";
   }
  });
}

initCountrySelector();
